import {
  Box,
  Button,
  Center,
  Flex,
  HStack,
  IconButton,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { useDeleteService, useServicesQuery } from "api/services";
import { useLabTests } from "api/tests";
import DeleteIcon from "assets/svg/DeleteIcon";
import EditIcon from "assets/svg/EditIcon";
import Alert from "generics/Alert";
import PageTitle from "generics/PageTitle";
import ToolbarPortal from "generics/ToolbarPortal";
import { isAllTruthy } from "helpers";
import React from "react";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router";

export default function Services() {
  const navigate = useNavigate();
  const servicesQuery = useServicesQuery();
  const labTestsQuery = useLabTests();

  return (
    <Box p="12">
      <ToolbarPortal>
        <Flex justifyContent="space-between" alignItems="center">
          <Flex justify="space-between" flexGrow={1} align="center">
            <PageTitle flexGrow={1}>Services</PageTitle>
            <Button
              size="sm"
              onClick={() => {
                navigate("/services/add");
              }}
              color="white"
              align="center"
              leftIcon={<FaPlus></FaPlus>}
            >
              Add Service
            </Button>
          </Flex>
        </Flex>
      </ToolbarPortal>
      <div>
        {isAllTruthy(servicesQuery.isLoading, labTestsQuery.isLoading) ? (
          <Center w="100%" h="100%">
            <Spinner size="lg" />
          </Center>
        ) : !servicesQuery.data?.length ? (
          <Center w="100%" h="100%">
            <Text>No Services</Text>
          </Center>
        ) : (
          <Table>
            <Thead
              fontSize="16px"
              fontWeight="600"
              borderBottom="1px solid #EBECF2"
            >
              <Tr>
                <Td>NAME</Td>
                <Td>DESCRIPTION</Td>
                <Td>TESTS</Td>
                <Td>ACTIONS </Td>
              </Tr>
            </Thead>
            <Tbody>
              {(servicesQuery?.data || []).map((service: any) => {
                return <ServiceItem service={service} key={service.id} />;
              })}
            </Tbody>
          </Table>
        )}
      </div>
    </Box>
  );
}

function ServiceItem({ service, onEdit }: any) {
  const navigate = useNavigate();
  const labTestsQuery = useLabTests();
  const [deleteService, deleteServiceInfo] = useDeleteService();
  const deleteModal = useDisclosure();

  return (
    <>
      <Alert
        confirmText="Delete"
        isOpen={deleteModal.isOpen}
        isLoading={deleteServiceInfo.isLoading}
        onOk={() => deleteService(service.id)}
        title="Delete Service"
        message={
          "Are you sure you want to delete service `" + service.name + "`?"
        }
        onClose={deleteModal.onClose}
      />
      <Tr textAlign="center" verticalAlign="top">
        <Td align="char">
          <Text fontSize="sm" color="settingText.500" fontWeight="500">
            {service.name}
          </Text>
        </Td>
        <Td>
          <Text fontSize="sm" color="settingText.500" fontWeight="400">
            {service.description}
          </Text>
        </Td>
        <Td>
          <Text fontSize="sm" color="settingText.500" fontWeight="400">
            {service?.tests
              .map(
                (testId: string) =>
                  labTestsQuery.data?.find((i) => i.id === testId)?.name
              )
              .join(", ")}
          </Text>
        </Td>
        <Td>
          <HStack>
            <IconButton
              size="sm"
              bg="transparent"
              color="black"
              icon={<EditIcon />}
              aria-label="edit-service"
              onClick={() => {
                navigate(`/services/${service.id}`);
              }}
            ></IconButton>
            <IconButton
              bg="transparent"
              color="red.300"
              icon={<DeleteIcon />}
              aria-label="delete-service"
              size="sm"
              onClick={() => deleteModal.onOpen()}
              isLoading={deleteServiceInfo.isLoading}
              // onClick={() => {
              //   // setAction("delete");
              //   // setSelectedTest(test);
              // }}
            ></IconButton>
          </HStack>
        </Td>
      </Tr>
    </>
  );
}
